<div
  #chatbotWrapper
  class="chatbot-wrapper"
  [class.open]="isOpen"
  [class.minimized]="isMinimized"
  [class.maximized]="isMaximized"
  [class.dragging]="isDragging"
  [ngStyle]="getWrapperStyle()">

  <!-- Floating Trigger Button -->
  <button *ngIf="!isOpen" class="chat-trigger-btn" (click)="toggleChat()" id="ai-chat-toggle-btn"
          [class.pulse]="!isOpen" title="AI Task Assistant">
    <span class="trigger-icon">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
      </svg>
    </span>
  </button>

  <!-- Chat Panel -->
  <div class="chat-panel" *ngIf="isOpen" [ngStyle]="getPanelStyle()">

    <!-- Resize Handles -->
    <div class="resize-handle resize-n"  (mousedown)="onResizeMouseDown($event, 'n')"></div>
    <div class="resize-handle resize-s"  (mousedown)="onResizeMouseDown($event, 's')"></div>
    <div class="resize-handle resize-e"  (mousedown)="onResizeMouseDown($event, 'e')"></div>
    <div class="resize-handle resize-w"  (mousedown)="onResizeMouseDown($event, 'w')"></div>
    <div class="resize-handle resize-ne" (mousedown)="onResizeMouseDown($event, 'ne')"></div>
    <div class="resize-handle resize-nw" (mousedown)="onResizeMouseDown($event, 'nw')"></div>
    <div class="resize-handle resize-se" (mousedown)="onResizeMouseDown($event, 'se')"></div>
    <div class="resize-handle resize-sw" (mousedown)="onResizeMouseDown($event, 'sw')"></div>

    <!-- Header (drag handle) -->
    <div class="chat-header" (mousedown)="onHeaderMouseDown($event)">
      <div class="header-left">
        <div class="ai-avatar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
        </div>
        <div class="header-info">
          <span class="header-title">AI Task Assistant</span>
        </div>
      </div>

      <div class="header-actions">
        <!-- Download Conversation -->
        <button class="icon-btn" (click)="downloadConversation()" title="Download conversation history" id="ai-chat-download-btn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
          </svg>
        </button>

        <!-- New Chat -->
        <button class="new-chat-btn" (click)="newChat()" title="Start a completely new chat" id="ai-chat-new-btn">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          <span class="btn-text">New Chat</span>
        </button>

        <!-- Maximize / Restore -->
        <button class="icon-btn" (click)="maximizeChat()"
                [title]="isMaximized ? 'Restore' : 'Maximize'" id="ai-chat-maximize-btn">
          <!-- Maximize icon -->
          <svg *ngIf="!isMaximized" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
          </svg>
          <!-- Restore icon -->
          <svg *ngIf="isMaximized" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
          </svg>
        </button>

        <!-- Close -->
        <button class="icon-btn close-btn" (click)="closeChat()" title="Close" id="ai-chat-close-btn">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Body (hidden when minimized) -->
    <div class="chat-body" *ngIf="!isMinimized">

      <!-- Messages -->
      <div class="messages-container" #messagesContainer>
        <div *ngFor="let msg of messages"
             class="message-row"
             [class.user-row]="msg.role === 'user'"
             [class.assistant-row]="msg.role === 'assistant'">

          <!-- Assistant Avatar -->
          <div class="msg-avatar assistant-av" *ngIf="msg.role === 'assistant'">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
            </svg>
          </div>

          <!-- Bubble -->
          <div class="msg-bubble"
               [class.user-bubble]="msg.role === 'user'"
               [class.assistant-bubble]="msg.role === 'assistant'"
               [class.has-table]="hasTableData(msg)"
               [class.error-bubble]="msg.error">

            <div *ngIf="msg.isLoading" class="typing-indicator">
              <span></span><span></span><span></span>
            </div>

            <p *ngIf="!msg.isLoading" class="msg-text" [innerHTML]="msg.text | nl2br:(msg.role === 'assistant' ? siteId : undefined):siteCode:msg.data"></p>

            <!-- Data Table (Hidden if a Chart is being displayed) -->
            <div *ngIf="hasTableData(msg) && !(msg.chartData && msg.chartData.labels?.length) && !isRagContext(msg)" class="data-table-wrapper">
              <div class="table-actions" *ngIf="msg.data && msg.data.length > 2">
                <button class="btn-export" (click)="exportToExcel(msg.data)" title="Export to Excel">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
                  </svg>
                  <span>Export to Excel</span>
                </button>
              </div>
              <!-- Check if data has IRN to render list -->
              <ng-container *ngIf="hasIRNColumn(msg.data); else standardTable">
                <div class="task-list">
                  <div class="task-list-item" *ngFor="let row of msg.data">
                    <div class="task-item-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                      <a [href]="getTaskUrl(row)" target="_blank" class="task-irn-link" style="font-weight: 600; font-size: 14px;">{{row.IRN || row.irn}}</a>
                      <div class="task-badges" style="display: flex; gap: 4px;">
                        <span class="badge category-badge" *ngIf="row.CategoryName || row.CategorName || row.categoryName" style="background: #eef2ff; color: #4f46e5; padding: 2px 6px; border-radius: 4px; font-size: 11px; font-weight: 500;">
                          {{ row.CategoryName || row.CategorName || row.categoryName }}
                        </span>
                        <span class="badge status-badge" *ngIf="row.StatusName || row.statusName" style="background: #f0fdf4; color: #16a34a; padding: 2px 6px; border-radius: 4px; font-size: 11px; font-weight: 500;">
                          {{ row.StatusName || row.statusName }}
                        </span>
                      </div>
                    </div>
                     <div class="task-meta" *ngIf="row.BuildingName || row.LevelName || row.TenancyName" style="color: #64748b; font-size: 12px; display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      <span>
                        <ng-container *ngIf="row.BuildingName">{{ row.BuildingName }}</ng-container>
                        <ng-container *ngIf="row.LevelName"> &middot; {{ row.LevelName }}</ng-container>
                        <ng-container *ngIf="row.TenancyName"> &middot; {{ row.TenancyName }}</ng-container>
                      </span>
                    </div>
                    <div class="task-date" *ngIf="row.DateRaised || row.dateRaised" style="color: #94a3b8; font-size: 11px; display: flex; align-items: center; gap: 4px;">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      {{ (row.DateRaised || row.dateRaised) | date:'mediumDate' }}
                    </div>
                  </div>

                </div>
              </ng-container>
              
              <ng-template #standardTable>
                <table class="data-table">
                  <thead>
                    <tr>
                      <th *ngFor="let col of getTableColumns(msg.data!)">{{ col }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of msg.data">
                      <td *ngFor="let col of getTableColumns(msg.data!)">{{ row[col] }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-template>
            </div>

            <!-- Chart Block (ANALYTICS responses) -->
            <div *ngIf="msg.chartData && msg.chartData.labels?.length" class="chart-block">
              <div class="chart-title">{{ msg.chartData.title }}</div>

              <!-- VERTICAL bars (default) -->
              <div *ngIf="msg.chartData.orientation !== 'horizontal'" class="chart-bars-vertical">
                <div *ngFor="let bar of getBarChartBars(msg)" class="chart-col">
                  <div class="chart-bar-track-v">
                    <div
                      class="chart-bar-fill-v"
                      [style.height.%]="bar.pct"
                      [style.background]="bar.color">
                    </div>
                  </div>
                  <span class="chart-value-v">{{ bar.value }}</span>
                  <span class="chart-label-v" [title]="bar.label">{{ bar.label }}</span>
                </div>
              </div>

              <!-- HORIZONTAL bars -->
              <div *ngIf="msg.chartData.orientation === 'horizontal'" class="chart-bars">
                <div *ngFor="let bar of getBarChartBars(msg)" class="chart-bar-row">
                  <span class="chart-label" [title]="bar.label">{{ bar.label }}</span>
                  <div class="chart-bar-track">
                    <div
                      class="chart-bar-fill"
                      [style.width.%]="bar.pct"
                      [style.background]="bar.color">
                    </div>
                  </div>
                  <span class="chart-value">{{ bar.value }}</span>
                </div>
              </div>

            </div>

            <div class="msg-meta" *ngIf="!msg.isLoading">
              <span class="msg-time">{{ formatTime(msg.timestamp) }}</span>
            </div>
          </div>

          <!-- User Avatar -->
          <div class="msg-avatar user-av" *ngIf="msg.role === 'user'">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="#4a4a4a">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
            </svg>
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="input-area">
        <div class="input-container">
          <textarea
            #inputField
            id="ai-chat-input"
            class="chat-input"
            [formControl]="questionCtrl"
            (keydown)="onKeydown($event)"
            (input)="adjustTextareaHeight()"
            placeholder="We are here to help you..."
            rows="1"
            [disabled]="isLoading">
          </textarea>
          <button
            *ngIf="!isLoading"
            class="send-btn"
            id="ai-chat-send-btn"
            (click)="sendMessage()"
            [disabled]="!questionCtrl.value?.trim()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </button>
          <button
            *ngIf="isLoading"
            class="send-btn stop-btn"
            id="ai-chat-stop-btn"
            (click)="stopGeneration()"
            title="Stop generating">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="6" width="12" height="12"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
